/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps, Theme } from '@mui/material';

export const forgotPasswordContainerSX = ({
	isMobile,
}: {
	isMobile?: boolean;
}): SxProps<Theme> => ({
	mt: { md: '80px', xs: '0px' },
	pt: { md: '41px', xs: '40px' },
	pb: { md: '41px', xs: '20px' },
	px: isMobile ? '14px' : '40px',
	boxShadow: 'none',
	borderRadius: '4px',
	opacity: 1,
	backgroundColor: isMobile ? '#FBFBFC' : '#ffffff',
});
